import { alphabeticalCompare } from 'shared'
import { BreakData, BreakDataTableProps } from './types'
import CIMSTable from 'components/CIMSTable'
import { dateFormatter } from '../../../../../../../../../../../utils/dateFormatter'

function BreakDataTable<T extends BreakData>({
  breakData,
  rowKey,
  help,
  diameter = { title: 'Diameter', width: 95 },
}: BreakDataTableProps<T>) {
  return (
    <CIMSTable
      disable={{ showAll: true }}
      records={Array.isArray(breakData) ? breakData : [breakData]}
      rowKey={rowKey}
      columns={[
        {
          title: 'Age',
          render: ({ age }) => age,
          help: help.Age,
          width: 78,
          align: 'center',
          sort: {
            with: 'callback',
            onCompare: (a, b) => alphabeticalCompare(a.age, b.age),
            default: 'ascend',
            priority: 1,
          },
        },
        {
          title: 'Break Date',
          help: help.BreakDate,
          align: 'center',
          width: 109,
          render: ({ breakDate }) => dateFormatter.simple(breakDate),
        },
        {
          title: 'Strength',
          help: help.Strength,
          align: 'right',
          width: 91,
          render: ({ strength }) => strength,
        },
        {
          title: 'Testing Lab',
          help: help.TestingLab,
          width: 110,
          render: ({ testingLab }) => testingLab?.name,
        },
        {
          title: 'Lab Tech',
          help: help.LabTech,
          width: 125,
          render: ({ labTech }) => labTech?.name,
        },
        {
          title: 'Lab Number',
          help: help.LabNumber,
          width: 131,
          render: ({ labNumber }) => labNumber,
          sort: {
            with: 'callback',
            onCompare: (a, b) => alphabeticalCompare(a.labNumber, b.labNumber),
            default: 'ascend',
            priority: 2,
          },
        },
        {
          ...diameter,
          help: help.Diameter,
          render: ({ diameter }) => diameter,
        },
        {
          title: 'Peak Load',
          help: help.PeakLoad,
          width: 105,
          align: 'right',
          render: ({ peakLoad }) => peakLoad,
        },
        {
          title: 'Type',
          help: help.Type,
          align: 'center',
          width: 68,
          render: ({ type }) => type,
        },
      ]}
      size="small"
      pagination={{ size: 'small' }}
    />
  )
}

export default BreakDataTable
